module.exports = __webpack_public_path__ + "static/loblaw-bg-5151faf137d85e26da0a6ccb9e115fcd.png";